import { MailDomainInfo, Resource } from "../resourcesSlice";
import { GetStringForMailboxQuota } from "../../../util/resourcesProto";
import {
  EditableResourceDetailsProps,
  domainInfoElementValidator,
  domainInfoTableElements,
  mailDomainInfoArray,
  mailboxQuotaField,
  yumTestArrayUniqueness,
} from "./MailResourceHelpers";
import {
  ResourceDetailCardBase,
  TableFormElement,
} from "./ResourceDetailCardBase";
import * as Yup from "yup";
import { regexConstants } from "../../../util/regexConstants";
import { InfoTableBase } from "../../../components/InfoTableBase";

const tableElements: TableFormElement<Resource>[] = [
  {
    title: "Org Prefix",
    key: "mailService.orgPrefix" as keyof Resource,
    validation: Yup.string().matches(regexConstants.resource.orgPrefix, "Must be 3-6 lowercase letters"),
  },
  {
    title: "Mailbox Quota",
    key: "mailService.mailboxQuota" as keyof Resource,
    formatter: GetStringForMailboxQuota,
    customFieldInputElement: mailboxQuotaField,
  },
  {
    title: "Shared Mailbox Quota",
    key: "mailService.sharedMailboxQuota" as keyof Resource,
    formatter: GetStringForMailboxQuota,
    customFieldInputElement: mailboxQuotaField,
  },
  {
    title: "Shared Mailbox Owner",
    key: "mailService.sharedMailboxOwner" as keyof Resource,
  },
  {
    title: "Domains",
    key: "mailService.domainsList" as keyof Resource,
    formatter: (domains: MailDomainInfo[]) => (
      <div>
        {domains.map((domain: MailDomainInfo) => (
          <InfoTableBase data={domain} elements={domainInfoTableElements} key={domain.domain}/>
        ))}
      </div>
    ),
    completelyCustomField: (key, formik) =>
      mailDomainInfoArray(key as keyof Resource, formik.values.mailService?.domainsList || [], formik.errors),
    validation: Yup.array()
      .of(Yup.object(domainInfoElementValidator))
      .max(5, `Maximum of 5 entries allowed`)
      .test('unique', "Duplicate email entry", yumTestArrayUniqueness),
  },
  {
    title: "Display Name Suffix",
    key: "mailService.displayNameSuffix" as keyof Resource,
    validation: Yup.string().matches(regexConstants.resource.mailDisplayNameSuffix, "Must be 3-15 letters, no spaces"),
  },
];

export const MailService = (
  props: EditableResourceDetailsProps<Resource>
) => (
  <ResourceDetailCardBase {...props}>{tableElements}</ResourceDetailCardBase>
);

export const mailServiceTableElements = tableElements;

